import { useEffect } from 'react';

const AD_CLIENT = 'ca-pub-5382189311583623';

/**
 * Reusable AdSense component
 * Note: For specific ad units, create ad units in Google AdSense dashboard and provide adSlot.
 * For auto ads, adSlot is optional and Google will automatically place ads.
 * @param {string} adSlot - AdSense ad slot ID (optional for auto ads, required for specific ad units)
 * @param {string} adFormat - Ad format: 'auto', 'rectangle', 'horizontal', 'vertical'
 * @param {object} style - Custom styles for the ad container
 * @param {string} className - Additional CSS classes
 */
const AdSense = ({ adSlot, adFormat = 'auto', style = {}, className = '' }) => {
  useEffect(() => {
    try {
      // Push ad to AdSense queue
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.error('AdSense error:', err);
    }
  }, []);

  // Default responsive styles
  const defaultStyle = {
    display: 'block',
    ...style
  };

  // Build props object - only include adSlot if provided
  const adProps = {
    className: `adsbygoogle ${className}`,
    style: defaultStyle,
    'data-ad-client': AD_CLIENT,
    'data-ad-format': adFormat,
    'data-full-width-responsive': 'true'
  };

  // Only add adSlot if provided (for specific ad units)
  if (adSlot) {
    adProps['data-ad-slot'] = adSlot;
  }

  return <ins {...adProps} />;
};

export default AdSense;

